var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHandScisBlu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    id: "Icon_awesome-hand-peace",
    className: "st0",
    d: "M31.1,15.2c-1.6,0-2.9,1.3-2.9,2.8h-0.6v-2.2c0-1.6-1.3-2.8-2.9-2.8 c-1.6,0-2.9,1.3-2.9,2.8c0,0,0,0,0,0V18h-0.6V3.4C21.4,1.5,19.9,0,18,0c-1.9,0-3.4,1.5-3.4,3.4c0,0,0,0,0,0V18h-1l-5-12.5 C7.9,3.8,5.9,2.9,4.2,3.6S1.5,6.2,2.2,8l5.3,13.4l-2.2,1.7C4.3,24,4,25.5,4.7,26.7l4.6,7.9c0.5,0.9,1.5,1.4,2.5,1.4h17.1 c1.3,0,2.5-0.9,2.8-2.2l2.3-9.6c0.1-0.2,0.1-0.4,0.1-0.6V18C34,16.4,32.7,15.2,31.1,15.2C31.1,15.2,31.1,15.2,31.1,15.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandScisBlu);
export default __webpack_public_path__ + "static/media/hand-scis-blu.0100419f.svg";
export { ForwardRef as ReactComponent };